$(function(){
    $('[autofocus]').focus();

    $('*').on('shown.bs.modal',function(){
        $('[autofocus]').focus();
    });

    $('aside *').prop('tabindex','-1');
    $('header *').prop('tabindex','-1');
});



// WEBPACK FOOTER //
// ./resources/assets/js/commons/setup-fields.js